// extracted by mini-css-extract-plugin
module.exports = {"middle_panel_list":"BookingOverview_middle_panel_list__3jFsK","middle_panel_list_0":"BookingOverview_middle_panel_list_0__kC8Rx"};